import React from 'react';
import About from '../components/About';

const AboutPage = () => {
  return (
    <div className="pt-20">
      <About />
    </div>
  );
};

export default AboutPage;
